import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const ContactCTA = () => (
  <section
    id="contact"
    data-testid="contact-cta-section"
    className="relative overflow-hidden bg-noir py-28 text-bone sm:py-36"
  >
    <div
      className="pointer-events-none absolute -right-24 -top-24 h-96 w-96 rounded-full border border-gold/20"
      aria-hidden="true"
    />
    <div
      className="pointer-events-none absolute -bottom-32 -left-16 h-72 w-72 rounded-full border border-gold/10"
      aria-hidden="true"
    />

    <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="mb-6 flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.3em] text-bone/50">
          <span className="inline-block h-px w-10 bg-gold" />
          Begin the Conversation
        </p>
        <h2 className="max-w-3xl font-serif text-4xl leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Let's set <span className="italic text-gold">your table.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15}>
        <p className="mt-8 max-w-lg text-base leading-relaxed text-bone/70 sm:text-lg">
          One email is all it takes. Tell us the occasion, the date and the
          guest count — Kasey replies personally, usually within a day.
        </p>
      </Reveal>

      <Reveal delay={0.25}>
        <a
          href="mailto:kas@kaseybeaumont.com?subject=Catering%20Enquiry%20—%20kaseybeaumont.com"
          data-testid="contact-email-link"
          className="link-sweep mt-12 inline-block font-serif text-2xl italic text-bone sm:text-4xl"
        >
          kas@kaseybeaumont.com
        </a>
      </Reveal>

      <Reveal delay={0.35}>
        <div className="mt-12">
          <a
            href="mailto:kas@kaseybeaumont.com?subject=Catering%20Enquiry%20—%20kaseybeaumont.com"
            data-testid="contact-cta-button"
            className="group inline-flex items-center gap-3 rounded-full bg-gold px-8 py-4 text-[13px] font-medium uppercase tracking-[0.16em] text-noir transition-colors duration-300 hover:bg-bone"
          >
            Request a Consultation
            <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
          <p className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-bone/40">
            Now booking — Autumn & Winter 2026
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
